import { configureStore } from '@reduxjs/toolkit';

//apis
import { authApi } from './apis/authApi';
import { userApi } from '../pages/access-control/routes/users/apis/userApi';

import { coreAPI } from '@/store/apis/coreApi';
import { purchaseApi } from '@/pages/purchase/apis/purchaseApi';
import { refinanceApi } from '@/pages/refinance/apis/refinanceApi';
import { dashboardAPI } from '@/pages/dashboard/apis/dashboardApi';
import { leadApi } from '@/pages/lead/apis/leadApi';
import { contactsApi } from '@/pages/contacts/apis/contactsApi';
import { complianceNoteApi } from '@/pages/note-generator/apis/complianceNoteApi';
import { preliminaryApi } from '@/pages/mortgage-workflow/apis/preliminaryApi';
import { brokerNoteApi } from '@/pages/mortgage-workflow/apis/brokerNoteApi';
import { infynityApi } from '@/pages/infynity/apis/infynityApi';
import { odinAppApi } from './apis/odinAppApi';
import { crmApi } from './apis/crmApi';
import { profileApi } from '@/pages/profile/api/profileApi';
import { websiteOAApi } from '@/pages/application/pages/website-oa/apis/websiteOAApi';
import { driveApi } from './apis/driveApi';
import { calcApi } from '@/pages/mortgage-workflow/apis/calcApi';
import { settingsApi } from './apis/settingsApi';
import { knowledgeBaseApi } from '@/pages/settings/components/knowledge-base/apis/knowledgeBaseApi';
import { gSheetAPI } from './apis/gSheetApi';
import { documentsApi } from './apis/documentsApi';
import { taxApi } from '@/pages/tax/apis/taxApi';
import { taxEntriesApi } from './apis/taxEntriesApi';
import { recommendationApi } from '@/pages/mortgage-workflow/apis/recommendationApi';
import { workbookApi } from '@/pages/mortgage-workflow/apis/workbookApi';
import { mortgageWorkflowApi } from '@/pages/mortgage-workflow/apis/mortgageWorkflowApi';
import { servicePricingApi } from '@/pages/mortgage-workflow/apis/servicePricingApi';
//slices
import auth from './slices/auth/authSlice';
import common from './slices/common/commonSlice';
import { ragAPI } from './apis/ragAPI';

import noteFormReducer from './slices/note/noteFormSlice';
import brokerNoteFormReducer from './slices/brokerNote/brokerNoteFormSlice';
import mortgageRecSlice from './slices/preliminary/mortgageRecFormSlice';

import { quickLinksApi } from './apis/quickLinkApi';

import { lendersApi } from './apis/lendersApi';
import { ratesSettingsApi } from './apis/ratesSettingsApi';
import { dealAPI } from './apis/dealApi';
import { webinarAPI } from '@/pages/application/pages/webinar/apis/webinarAPI';
import { applicationApi } from '@/pages/application/apis/applicationApi';

// search api
import { searchApi } from './apis/searchApi';
import { taxDealsApi } from './apis/taxDealsApi';
import { cgtCalculationsApi } from './apis/cgtCalculationsApi';
import { taxReturnApi } from './apis/taxReturnApi';
import { taxDocumentsApi } from './apis/taxDocumentsApi';
import { taxDriveSyncApi } from './apis/taxDriveSyncApi';
import { taxDocumentsCheckApi } from './apis/taxDocumentsCheckApi';
import { rbacApi } from '@/pages/access-control/routes/roles/apis/rbacApi';
import { calculationAPI } from '@/pages/mortgage-workflow/routes/Calculations/apis/calculationApi';
import { creditAnalystCalculationAPI } from '@/pages/application/credit-analyst/pages/calculations/apis/calculationApi';
import { cosApi } from '@/pages/tools/cos-extracted/apis/cosAPi';
import { csaPdfApi } from '@/pages/tools/csa-pdf-generate/apis/csaPdfApi';
import { odinOtpApi } from '@/pages/tools/odin-otp/apis/odinOtpApi';
import { extractContentApi } from '@/pages/tools/run-extraction/apis/extractContentApi';
import { documentVerificationApi } from '@/pages/tools/document-translation/apis/documentVerificationApi';
import { promptsSchemaApi } from './apis/promptsSchemaApi';
import { taxWorkbookApi } from './apis/taxWorkbookApi';
import { blueprintApi } from '@/pages/mortgage-workflow/routes/Blueprint/lite/apis/blueprintApi';
import { propertyDetailApi } from './apis/propertyDetailApi';
import { infynityCreationApi } from './apis/infynityCreationApi';
import { dataAnalyticsApi } from '@/pages/data-analytics/apis/dataAnalyticsApi';
import { metaGraphApi } from '@/pages/data-analytics/routes/meta-dashboard-v2/apis/metaGraphApi';
import { assessmentApi } from '@/pages/assessments/apis/assessmentApi';
import { calculationLenderSheetApi } from './apis/calculationLenderSheetApi';
import { stageTransitionApi } from './apis/stageTransitionApi';
import { documentInviteApi } from '@/pages/documents-invite/apis/documentInviteApi';
import { documentIngestApi } from '@/pages/documents-invite/apis/documentIngestApi';
import { portalDocumentsApi } from '@/pages/application/credit-analyst/pages/portal-documents/apis/portalDocumentsApi';
import { embedApi } from '@/pages/marketing/apis/embedApi';

export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [purchaseApi.reducerPath]: purchaseApi.reducer,
    [refinanceApi.reducerPath]: refinanceApi.reducer,
    [coreAPI.reducerPath]: coreAPI.reducer,
    [dashboardAPI.reducerPath]: dashboardAPI.reducer,
    [calculationAPI.reducerPath]: calculationAPI.reducer,
    [creditAnalystCalculationAPI.reducerPath]:
      creditAnalystCalculationAPI.reducer,
    [ragAPI.reducerPath]: ragAPI.reducer,
    [leadApi.reducerPath]: leadApi.reducer,
    [contactsApi.reducerPath]: contactsApi.reducer,
    [infynityApi.reducerPath]: infynityApi.reducer,
    [complianceNoteApi.reducerPath]: complianceNoteApi.reducer,
    [preliminaryApi.reducerPath]: preliminaryApi.reducer,
    [odinAppApi.reducerPath]: odinAppApi.reducer,
    [crmApi.reducerPath]: crmApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [websiteOAApi.reducerPath]: websiteOAApi.reducer,
    [driveApi.reducerPath]: driveApi.reducer,
    [quickLinksApi.reducerPath]: quickLinksApi.reducer,
    [lendersApi.reducerPath]: lendersApi.reducer,
    [brokerNoteApi.reducerPath]: brokerNoteApi.reducer,
    [calcApi.reducerPath]: calcApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [knowledgeBaseApi.reducerPath]: knowledgeBaseApi.reducer,
    [gSheetAPI.reducerPath]: gSheetAPI.reducer,
    [dealAPI.reducerPath]: dealAPI.reducer,
    [documentsApi.reducerPath]: documentsApi.reducer,
    [taxApi.reducerPath]: taxApi.reducer,
    [webinarAPI.reducerPath]: webinarAPI.reducer,
    [searchApi.reducerPath]: searchApi.reducer,
    [taxEntriesApi.reducerPath]: taxEntriesApi.reducer,
    [taxDealsApi.reducerPath]: taxDealsApi.reducer,
    [cgtCalculationsApi.reducerPath]: cgtCalculationsApi.reducer,
    [taxReturnApi.reducerPath]: taxReturnApi.reducer,
    [taxDocumentsApi.reducerPath]: taxDocumentsApi.reducer,
    [taxDriveSyncApi.reducerPath]: taxDriveSyncApi.reducer,
    [taxDocumentsCheckApi.reducerPath]: taxDocumentsCheckApi.reducer,
    [recommendationApi.reducerPath]: recommendationApi.reducer,
    [workbookApi.reducerPath]: workbookApi.reducer,
    [mortgageWorkflowApi.reducerPath]: mortgageWorkflowApi.reducer,
    [applicationApi.reducerPath]: applicationApi.reducer,
    [servicePricingApi.reducerPath]: servicePricingApi.reducer,
    [rbacApi.reducerPath]: rbacApi.reducer,
    [cosApi.reducerPath]: cosApi.reducer,
    [csaPdfApi.reducerPath]: csaPdfApi.reducer,
    [odinOtpApi.reducerPath]: odinOtpApi.reducer,
    [extractContentApi.reducerPath]: extractContentApi.reducer,
    [documentVerificationApi.reducerPath]: documentVerificationApi.reducer,
    [ratesSettingsApi.reducerPath]: ratesSettingsApi.reducer,
    [promptsSchemaApi.reducerPath]: promptsSchemaApi.reducer,
    [taxWorkbookApi.reducerPath]: taxWorkbookApi.reducer,
    [blueprintApi.reducerPath]: blueprintApi.reducer,
    [propertyDetailApi.reducerPath]: propertyDetailApi.reducer,
    [infynityCreationApi.reducerPath]: infynityCreationApi.reducer,
    [dataAnalyticsApi.reducerPath]: dataAnalyticsApi.reducer,
    [metaGraphApi.reducerPath]: metaGraphApi.reducer,
    [assessmentApi.reducerPath]: assessmentApi.reducer,
    [calculationLenderSheetApi.reducerPath]: calculationLenderSheetApi.reducer,
    [stageTransitionApi.reducerPath]: stageTransitionApi.reducer,
    [documentInviteApi.reducerPath]: documentInviteApi.reducer,
    [documentIngestApi.reducerPath]: documentIngestApi.reducer,
    [portalDocumentsApi.reducerPath]: portalDocumentsApi.reducer,
    [embedApi.reducerPath]: embedApi.reducer,
    auth: auth,
    common: common,
    noteForm: noteFormReducer,
    brokerNoteForm: brokerNoteFormReducer,
    mortgageRecSlice: mortgageRecSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      userApi.middleware,
      purchaseApi.middleware,
      refinanceApi.middleware,
      coreAPI.middleware,
      dashboardAPI.middleware,
      ragAPI.middleware,
      leadApi.middleware,
      contactsApi.middleware,
      complianceNoteApi.middleware,
      preliminaryApi.middleware,
      infynityApi.middleware,
      odinAppApi.middleware,
      crmApi.middleware,
      profileApi.middleware,
      websiteOAApi.middleware,
      driveApi.middleware,
      quickLinksApi.middleware,
      lendersApi.middleware,
      brokerNoteApi.middleware,
      calcApi.middleware,
      settingsApi.middleware,
      knowledgeBaseApi.middleware,
      gSheetAPI.middleware,
      dealAPI.middleware,
      documentsApi.middleware,
      taxApi.middleware,
      webinarAPI.middleware,
      searchApi.middleware,
      taxEntriesApi.middleware,
      taxDealsApi.middleware,
      cgtCalculationsApi.middleware,
      taxReturnApi.middleware,
      taxDocumentsApi.middleware,
      taxDriveSyncApi.middleware,
      taxDocumentsCheckApi.middleware,
      recommendationApi.middleware,
      workbookApi.middleware,
      mortgageWorkflowApi.middleware,
      applicationApi.middleware,
      servicePricingApi.middleware,
      rbacApi.middleware,
      calculationAPI.middleware,
      creditAnalystCalculationAPI.middleware,
      cosApi.middleware,
      csaPdfApi.middleware,
      odinOtpApi.middleware,
      extractContentApi.middleware,
      documentVerificationApi.middleware,
      ratesSettingsApi.middleware,
      promptsSchemaApi.middleware,
      taxWorkbookApi.middleware,
      blueprintApi.middleware,
      propertyDetailApi.middleware,
      infynityCreationApi.middleware,
      dataAnalyticsApi.middleware,
      metaGraphApi.middleware,
      assessmentApi.middleware,
      calculationLenderSheetApi.middleware,
      stageTransitionApi.middleware,
      documentInviteApi.middleware,
      documentIngestApi.middleware,
      portalDocumentsApi.middleware,
      embedApi.middleware,
    ),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
